<template>
    <div class="table_wrap">
        <el-table
                :data="List"
                style="width: 100%"
                empty-text="데이터가 없습니다."

        >
            <el-table-column
                    class="table_no"
                    type="index"
                    label="No"
                    width="80"
                    class-name="num text-center"
                    :index="tableIdx"
            >
            </el-table-column>
            <el-table-column label="아이디" prop="mb_id" class-name="text-center"></el-table-column>
            <el-table-column label="닉네임" prop="mb_nick" class-name="text-center"></el-table-column>
            <el-table-column
                    label="상태" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{orderStatusName(scope.row.o_status)}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="상품명" prop="i_name" class-name="text-center"></el-table-column>
            <el-table-column
                    label="금액" width="150" class-name="text-center">
                <template slot-scope="scope">
                        <span>
                            ${{scope.row.o_price}}
                        </span>
                </template>
            </el-table-column>
            <el-table-column label="결제번호" prop="o_id" class-name="text-center"></el-table-column>
            <el-table-column
                    label="일시" width="150" class-name="text-center">
                <template slot-scope="scope">
                    <span>
                        {{returnDate(scope.row.created_at)}}
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagnation_wrap">
            <el-pagination v-if="filterSet.page.total > 0"
                           :page-size="filterSet.page.size"
                           :current-page.sync="filterSet.page.page"
                           :pager-count="11"
                           layout="prev, pager, next"
                           :total="filterSet.page.total"
                           @current-change="changePage('page', filterSet.page.page)"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
    import VuxAlert from "@/mixins/vux-alert";
    import listMixins from "@/mixins/listMixins";
    import filterMixins from "@/mixins/filterMixins";
    import {loginType} from "@/service/MemberService";
    import {orderStatus} from "@/service/orderService";
    import util from "@/mixins/util";
    export default {
        name: 'MemberOrderComponent',
        mixins: [VuxAlert, filterMixins, listMixins],
        components: {
        },
        props: {
            memberKey: {

            },
        },
        data() {
            return{

            }
        },
        created() {
            this.setParserType('url', this.$route.fullPath);
            let listOptions = {
                url : this.$api.$order.getOrder,
                defaultParams : {
                    ip: 1,
                    no: this.memberKey,
                },
            }
            this.initList('api', listOptions);
        },
        mounted() {
            this.isInitPage = true;
            this.getList();
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods:{
            tableIdx(index) {
                return this.filterSet.page.total - index - (this.filterSet.page.page - 1) * this.filterSet.page.size;
            },
            returnDate(date=null) {
                if(!date) {
                    return '';
                }
                return this.$moment.unix(date).locale('kr').format('YYYY-MM-DD HH:mm')
            },
            loginTypeName(type) {
                if(util.isEmpty(type) || util.isEmpty(loginType[type])) {
                    return '이메일계정'
                }
                return loginType[type];
            },
            orderStatusName(type) {
                if(util.isEmpty(type) || util.isEmpty(orderStatus[type])) {
                    return ''
                }
                return orderStatus[type];
            },
        },
        watch: {

        },
    }
</script>
